import { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./seo-smm-pack-pricing.css";
import priceList from "@/data/services/online-marketing/price-list.json";
import infoData from "@/data/services/online-marketing/seo-smm/seo-smm.json";
import faq from "@/data/services/online-marketing/seo-smm/faq.json";
import PageSEO from "@/components/common/PageSEO";
import Intro from "@/components/service/components/intro/Intro";
import PriceList from "@/components/service/components/price-list/PriceList";
import VisualBenefits from "@/components/service/components/visual-benefits/VisualBenefits";
import Faq from "@/components/contact/faq/Faq";
import WebBanner from "@/components/service/components/banner/WebBanner";
import TextBubbles from "@/components/service/web-design/text-bubbles/TextBubbles";
import Inclusives from "@/components/service/components/inclusives/Inclusives";
import Exclusives from "@/components/service/components/exclusives/Exclusives";
import WebDesignIcons from "@/components/service/web-design/icons/Icons";
import Spacing from "@/components/common/Spacing";
import Button from "@/components/common/buttons/Button";

const PachetSeoSmm = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBannerClick = () => {
    window.location.assign("/portfoliu/smm-content");
  };

  return (
    <>
      <PageSEO section="services" keyName="seo-smm" />
      <Intro data={infoData} branding={true} />

      {/* BANNER */}
      <Container style={{ height: "100%" }}>
        <WebBanner
          onClick={handleBannerClick}
          img="/project-images/seo.smm.webp"
        />
      </Container>

      {/* TEXT BUBBLES (textone + textwo) */}
      <Container>
        <TextBubbles info={infoData} />
        <Spacing size={4} />
      </Container>

      <VisualBenefits icon="bullet" data={infoData} />

      <Container>
        <Spacing size={4} />
        <WebDesignIcons info={infoData} />
        <Spacing size={4} />

        {/* INCLUSIVES */}
        <Inclusives
          data={{
            inclusiveTitle: infoData.inclusiveTitle,
            inclusives: infoData.inclusives,
          }}
        />

        {/* EXCLUSIVES */}
        <Exclusives
          data={{
            exclusiveTitle: infoData.exclusiveTitle,
            exclusives: infoData.exclusives,
          }}
        />

        {/* PRICING CARD CTA */}
        <Spacing size={6} />
        <Row className="justify-content-center">
          <Col lg={8} className="text-center">
            <div
              style={{
                borderRadius: "22px",
                padding: "1px",
                background:
                  "linear-gradient(135deg, rgba(36,196,157,0.35), rgba(238,177,127,0.35))",
                marginBottom: "2rem",
              }}
            >
              <div
                className="seo-smm-pack-pricing-card"
                style={{
                  background:
                    "linear-gradient(135deg, #050505 0%, #0c1104 100%)",
                  borderRadius: "20px",
                  padding: "clamp(1.5rem, 4vw, 3rem)",
                  position: "relative",
                  overflow: "visible",
                  minHeight: "auto",
                }}
              >
                {/* Glow effect is now handled entirely via CSS */}
                <div className="seo-smm-pack-glow-effect" />

                <h2
                  style={{
                    fontSize: "clamp(1.5rem, 5vw, 2.5rem)",
                    fontWeight: "bold",
                    color: "#fcfff9",
                    marginBottom: "1rem",
                    fontFamily:
                      "Space Grotesk, system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
                    position: "relative",
                    zIndex: 2,
                  }}
                >
                  PACHET COMPLET SEO + SMM
                </h2>

                <div
                  style={{
                    fontSize: "clamp(1.8rem, 6vw, 3rem)",
                    fontWeight: "bold",
                    color: "#a9f2d0",
                    marginBottom: "1rem",
                    position: "relative",
                    zIndex: 2,
                    lineHeight: "1.2",
                  }}
                >
                  €1.500/lună x 3 luni = €4.500
                  <br />
                  LUNA 4: BANII RECUPERAȚI GARANTAT!
                </div>

                <p
                  style={{
                    fontSize: "clamp(1rem, 3vw, 1.2rem)",
                    color: "#9aa19f",
                    marginBottom: "1rem",
                    lineHeight: "1.6",
                    position: "relative",
                    zIndex: 2,
                  }}
                >
                  Singura garanție contractuală din România!
                  <br />
                  Server-side tracking + SEO domination + SMM profesionist. Nu
                  te costă nimic - se autofinanțează!
                </p>

                <p
                  style={{
                    fontSize: "0.8rem",
                    color: "#9aa19f",
                    marginBottom: "2rem",
                    lineHeight: "1.4",
                    position: "relative",
                    zIndex: 2,
                    fontStyle: "italic",
                    opacity: 0.8,
                  }}
                >
                  *Ori recuperezi investiția din rezultatele generate, ori ți-o
                  restituim din buzunarul nostru. CONTRACT semnat!
                </p>

                <div className="seo-smm-pack-button-container">
                  <Button
                    className="menu-button button-body seo-smm-pack-demo-button"
                    text="Vreau să discutăm!"
                    onClick={() =>
                      window.open(
                        "https://wa.me/40745371620?text=Vreau pachetul SEO+SMM cu garanție contractuală €1.500/lună!",
                        "_blank",
                      )
                    }
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Spacing size={6} />

        <PriceList data={priceList} />
        <Faq data={faq} />
      </Container>
    </>
  );
};

export default PachetSeoSmm;
